import script from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=658be8e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658be8e6"]])

export default __exports__